import { render, staticRenderFns } from "./LocationAddress.vue?vue&type=template&id=f235dfc4"
import script from "./LocationAddress.vue?vue&type=script&lang=js"
export * from "./LocationAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports